import React, { useEffect, useState, SyntheticEvent } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {Form, Button} from 'react-bootstrap';
import api from '../../services/api';
import Swal from 'sweetalert2';
import {format} from "fecha";

const Details = (props) => {
    const [Token, setToken] = useState('');
    const [Content, setContent] = useState('');
    const [StartDate, setStartDate] = useState('');
    const [EndDate, setEndDate] = useState('');
    const [Enabled, setEnabled] = useState(true);
    const [id, setId] = useState(props?.location?.aboutProps?.id);
    const [loadingData, setLoadingData] = useState(false);
    const history = useHistory();

    const getById = async () => {
        if (id > 0) {
            setLoadingData(true);
            try {
                api.get("schedule/" + id )
                    .then(function (response) {
                        if (response.status == 200) {
                            var result = response.data;
                            setToken(result.token_name);
                            setContent(result.content_name);
                            setStartDate(new Date(result.start_date).toLocaleDateString());
                            setEndDate(new Date(result.end_date).toLocaleDateString());
                            setEnabled(result.is_active);
                        }
                        setLoadingData(false);
                    })
                    .catch(function (error) {
                        //Swal.fire({
                        //    title: 'Erreur!',
                        //    text: "Une erreur s'est produite",
                        //    icon: 'error',
                        //    confirmButtonText: 'OK'
                        //});
                        setLoadingData(false);
                    });
            } catch (err) {
                //Swal.fire({
                //    title: 'Erreur!',
                //    text: "Une erreur s'est produite",
                //    icon: 'error',
                //    confirmButtonText: 'OK'
                //});
                setLoadingData(false);
            }
        }else{
            return history.push('/manage/schedules');
        }
    }

    useEffect(() => {
        getById();
        var selector = document.getElementById('title-section-id');
        if(selector != undefined)
            selector.textContent = "Schedule details";
    }, []);

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}><div className="preloader-spinner"></div></div>
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Token: </label>
                            <p className="card-text">{Token}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Content: </label>
                            <p className="card-text">{Content}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Start Date: </label>
                            <p className="card-text">{StartDate}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>End Date: </label>
                            <p className="card-text">{EndDate}</p>
                        </div>
                        <div className="col-sm-12 col-md-6 mb-25">
                            <label>Is Active: </label>
                            <p className="card-text">{Enabled ? "True" : "False"}</p>
                        </div>
                    </div>
                </div>
                <div className="card-footer">
                    <NavLink className="btn btn-secondary" to="/manage/tokens"><i className="fa fa-chevron-left"></i> Back</NavLink>
                </div>
            </div>
        </>
    );
};

export default Details;
